"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Month = require("./Month");
var MonthSegments = function MonthSegments(props) {
  var months = props.months,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    onClick = props.onClick;
  if ((0, _isEmpty2["default"])(months.filter(Boolean))) return null;
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    isMobile: isMobile,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
    isMobile: isMobile
  }, months.map(function (month) {
    return /*#__PURE__*/_react["default"].createElement(_Month.Month, {
      key: month.text,
      month: month,
      onClick: onClick && onClick(month)
    });
  })));
};
var StyledContainer = _styledComponents["default"].section.withConfig({
  displayName: "MonthSegments__StyledContainer",
  componentId: "sc-kugmlz-0"
})(["box-shadow:0px 1px 2px rgba(210,208,197,0.9),0px 10px 15px rgba(216,214,204,0.9);padding:5px;background:#fff;border-bottom-left-radius:6px;border-bottom-right-radius:6px;font-size:14px;line-height:16px;", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && "\n    font-size: 12px;\n    background-color: transparent;\n    padding: 0;\n  ";
});
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MonthSegments__StyledWrapper",
  componentId: "sc-kugmlz-1"
})(["width:100%;display:flex;cursor:pointer;overflow-y:hidden;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{height:0px;background:transparent;}"]);
var _default = exports["default"] = MonthSegments;